import { SelectOption } from '@/types'
import { DEFAULT_BANNER_URL } from '@/constants/stackup'

export const STEP_ELIGIBILITY = 'Eligibility' as const
export const STEP_PERSONAL_INFO = 'Personal Info' as const
export const STEP_BACKGROUND = 'Background' as const
export const STEP_TEAM_INFO = 'Challenge & Team Info' as const
export const STEP_TICKETING = 'Ticketing' as const
export const STEP_COMPLETE = 'Complete' as const

export const RegistrationConstants = Object.freeze({
  DEFAULT_BANNER_URL,
  DISCORD_CHANNEL: 'https://discord.gg/3x3h2z6A63' as const,
  STEP_LABELS: [
    STEP_ELIGIBILITY,
    STEP_PERSONAL_INFO,
    STEP_BACKGROUND,
    STEP_TEAM_INFO,
    STEP_TICKETING,
  ] as const,
})

// Matches StackUp Member's `validates :first_name, :last_name, length:
// { maximum: 35 }`. Without this the form would accept a longer name that
// Accounts::MemberProfileAttributes then silently truncates, leaving the
// hackathon User and the StackUp Member holding different names.
export const NAME_MAX_CHARACTERS = 35

export const GENDER_OPTIONS: SelectOption[] = [
  { value: 'female', label: 'Female' },
  { value: 'male', label: 'Male' },
  { value: 'non_binary', label: 'Non-Binary' },
  { value: 'unspecified', label: 'Prefer not to say' },
]

export const TEAM_STATUSES: SelectOption[] = [
  { value: 'solo', label: 'Hacking Solo' },
  { value: 'team_completed', label: 'In a Complete Team' },
  { value: 'join_team', label: 'Looking to join a team' },
  { value: 'more_member', label: 'Looking for more members' },
]

export const BACKGROUND_PROFILES: SelectOption[] = [
  { value: 'student_level', label: 'Student' },
  { value: 'entry_level', label: 'Entry-Level' },
  { value: 'mid_senior_level', label: 'Mid-Senior Level' },
  { value: 'experienced_level', label: 'Experienced' },
]
